export default __webpack_public_path__ + "src/assets/icn-status-badge-success.24e48c3a93ef55d0a0992ecb2a8ba6c0.svg";